export const FORM_LANGUAGE = {
  required: () => 'Required field',
  numbersOnly: () => 'Only numbers allowed',
  integersOnly: () => 'Only whole numbers allowed',
  noSpaces: () => 'No spaces allowed',
  creditCard: () => badFormat('credit card'),
  expDate: () => 'Exp date must be in the format MM/YY',
  ccv: () => badFormat('CCV'),
  zip: (countryCode = 'US') => {
    if (countryCode === 'US') {
      return badFormat('US ZIP code')
    } else {
      return badFormat(`${countryCode} postal code`)
    }
  },
  email: () => badFormat('email'),
  phone: () => badFormat('US phone number'),
  amount: () => badFormat('amount'),
  passwordLength: (num) => `Password must have at least ${num} characters`,
  passwordMatch: () => 'Passwords do not match',
  fileType: () => 'Invalid file type',
  unique: (input) => `${input} is already taken`,
}

// expects schema.describe() https://yup-docs.vercel.app/docs/Api/schema#schemadescribeoptions-resolveoptions-schemadescription
export const requiredFieldMissing = (yupSchemaDescription, formValues) => {
  if (!yupSchemaDescription) {
    return false
  }

  if (yupSchemaDescription.type === 'array' && Array.isArray(formValues)) {
    return formValues.some((formValue) => requiredFieldMissing(yupSchemaDescription.innerType, formValue))
  }

  if (yupSchemaDescription.type === 'object') {
    return Object.entries(yupSchemaDescription?.fields).some(([key, field]) => requiredFieldMissing(field, formValues[key]))
  }

  return yupSchemaDescription.optional === false && [null, undefined, ''].includes(formValues)
}

function badFormat(field) {
  return `Not a valid ${field}`
}
